<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <section>
            <h1 class="pb-5">Speaker Info</h1>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.pro_name"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Slug</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ form.slug }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mb-10">
                <ArticleEditor
                  v-if="showDesc"
                  v-model="form.pro_shortdesc"
                  :config="{
                    plugins: ['blockcode'],
                    addbarAdd: ['text', 'card'],
                    css: '/article-editor/css/',
                    format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                    align: {
                      left: 'text-left',
                      center: 'text-center',
                      right: 'text-right',
                      justify: 'text-justify'
                    }
                  }"
                ></ArticleEditor>
                <vs-textarea
                  style="display: none"
                  class="w-full"
                  v-model="form.pro_shortdesc"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Speaker Image</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <!-- <vs-input
                type="file"
                ref="poster"
                name="poster"
                class="w-full"
                v-model="file.poster"
                @change="setPoster"
                />
                <span
                class="text-danger text-sm"
                v-show="errors.has('poster')"
                >{{ errors.first("poster") }}</span
                > -->
                <div v-if="file.poster || posterImg">
                  <img
                    :src="posterImg"
                    :width="imageWidth"
                    :height="imageHeight"
                  />
                </div>
                <div
                  v-else
                  class="default-upload"
                  style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
                >
                  <vs-button
                    style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                    color="dark"
                    type="border"
                    @click="chooseImage()"
                  >
                    <span>Upload</span>
                  </vs-button>
                </div>
                <div
                  class="grid-button-upload"
                  style="margin-top: 8px;display: grid;grid-template-columns: repeat(2, min-content);grid-gap: 10px;"
                >
                  <!-- secondary / border  >> btn-->
                  <vs-button
                    v-if="file.poster || posterImg"
                    color="dark"
                    type="border"
                    icon="autorenew"
                    style="display: flex"
                    @click="chooseImage()"
                  >
                    <span>Change</span>
                  </vs-button>
                  <input
                    id="file-upload-img"
                    class="d-none"
                    @change="onUploadImages()"
                    type="file"
                    ref="fileImage"
                    :accept="acceptFile"
                  />
                  <vs-button
                    v-if="file.poster || posterImg"
                    color="dark"
                    type="border"
                    icon="delete_forever"
                    style="display: flex"
                    @click="popupActivo = true"
                  >
                    Remove
                  </vs-button>
                  <vs-popup
                    classContent="popup-confirm"
                    title="Confirm Delete"
                    :active.sync="popupActivo"
                  >
                    <div>Are you sure you want to delete the image?</div>
                    <div class="wrap-button">
                      <vs-button
                        color="dark"
                        type="border"
                        style="font-size: 12px !important;"
                        @click="popupActivo = false"
                      >
                        No
                      </vs-button>
                      <vs-button
                        color="primary"
                        style="font-size: 12px !important;"
                        @click="removeposter"
                      >
                        Yes
                      </vs-button>
                    </div>
                  </vs-popup>
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Listing Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Publish Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <hr />
          <!-- Related Items Card -->
          <section>
            <template>
              <section>
                <h1 class="py-5 card-title">Related Items</h1>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Related Videos</span>
                    <div style="font-size: 0.75rem; color: #aaa">
                      These videos will be recommended when viewing the video
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <div>
                      <v-select
                        class="hide-select-action"
                        v-model="related_video_ids_search"
                        :options="relatedEventSearchOptions"
                        @input="onAddEventRelated"
                        placeholder="Search Video"
                      ></v-select>
                      <div class="px-1 mt-4">
                        <draggable
                          v-model="related_video_ids_input"
                          tag="div"
                          class="row"
                        >
                          <div
                            class="col col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2 cursor-move"
                            v-for="(item, index) in related_video_ids_input"
                            :key="index"
                          >
                            <vs-card class="position-relative">
                              <div
                                class="close-btn"
                                @click="removeRelatedEvent(item.value)"
                              >
                                <i class="fas fa-times-circle"></i>
                              </div>
                              <div class="">
                                <img
                                  :src="item.poster"
                                  class="img-fluid"
                                  alt=""
                                />
                              </div>
                              <div class="mt-2 overflow-hidden card-label">
                                {{ item.label }}
                              </div>
                            </vs-card>
                          </div>
                        </draggable>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Related Products</span>
                    <div style="font-size: 0.75rem; color: #aaa">
                      These products will be recommended when viewing the event
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <v-select
                      class="hide-select-action"
                      v-model="related_product_ids_search"
                      :options="relatedProductSearchOptions"
                      @input="onAddProductRelated"
                      placeholder="Search Product"
                    ></v-select>
                    <div class="px-1 mt-2">
                      <draggable
                        v-model="related_product_ids_input"
                        tag="div"
                        class="row"
                      >
                        <div
                          class="col col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2 cursor-move"
                          v-for="(item, index) in related_product_ids_input"
                          :key="index"
                        >
                          <vs-card class="position-relative">
                            <div
                              class="close-btn"
                              @click="removeRelatedProduct(item.value)"
                            >
                              <i class="fas fa-times-circle"></i>
                            </div>
                            <div class="">
                              <img
                                :src="item.poster"
                                class="img-fluid"
                                alt=""
                              />
                            </div>
                            <div class="mt-2 overflow-hidden card-label">
                              {{ item.label }}
                            </div>
                          </vs-card>
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Speakers</span>
                    <div style="font-size: 0.75rem; color: #aaa">
                      These speakers will be recommended when viewing the
                      speaker
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <v-select
                      class="hide-select-action"
                      v-model="speakers_search"
                      :options="speakers_select_options"
                      @input="onAddSpeaker"
                      placeholder="Search Speaker"
                    ></v-select>
                    <div class="px-1 mt-2">
                      <draggable v-model="speakers" tag="div" class="row">
                        <div
                          class="col col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2 cursor-move"
                          v-for="(item, index) in speakers"
                          :key="index"
                        >
                          <vs-card class="position-relative">
                            <div
                              class="close-btn"
                              @click="removeSpeaker(item.value)"
                            >
                              <i class="fas fa-times-circle"></i>
                            </div>
                            <div class="">
                              <img
                                :src="item.poster"
                                class="img-fluid"
                                alt=""
                              />
                            </div>
                            <div class="mt-2 overflow-hidden card-label">
                              {{ item.label }}
                            </div>
                          </vs-card>
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div> -->
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Tags</span>
                    <div style="font-size: 0.75rem; color: #aaa">
                      Use tags to link related content together for better
                      recommendations
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <v-select
                      v-model="tags"
                      multiple
                      taggable
                      :options="tag_select_options"
                      placeholder="Add or Search Tag"
                      :filter="customTagFilter"
                      @input="onTagInput"
                    ></v-select>
                  </div>
                </div>
              </section>
            </template>
          </section>

          <hr />
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Update Speaker</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import moment from "moment";
import { mapState } from "vuex";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import vSelect from "vue-select";
import draggable from "vuedraggable";
import ArticleEditor from "@/components/ArticleEditor.vue";

const dict = {
  form: {
    name: {
      required: "Please enter an event name"
    },
    slug: {
      required: "Please enter your last name",
      alpha: "Your last name may only contain alphabetic characters"
    }
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
  components: { flatPickr, vSelect, ArticleEditor, draggable },
  props: ["speaker_id"],
  data: () => ({
    showDesc: true,
    valid: true,
    editorOption: {
      modules: {
        toolbar: "#toolbar"
      }
    },
    editor2Option: {
      modules: {
        toolbar: "#toolbar-2"
      }
    },
    event_filter: "",
    form: {
      e: "",
      s: "",
      target: "merchant",
      speaker_id: "",
      pro_name: "",
      poster: "",
      slug: "",
      pro_shortdesc: "",
      pro_longdesc: "",
      publish_status: true,
      listing_status: true,
      video_url: "",
      keywords: "",
      related_product_ids: "",
      related_speaker_ids: ""
    },
    file: {
      poster: null
    },
    datetime: null,
    configFromdateTimePicker: {
      minDate: null,
      maxDate: null,
      dateFormat: "d-m-Y H:i",
      enableTime: true,
      enableSeconds: false
    },
    configTodateTimePicker: {
      minDate: null,
      maxDate: null,
      dateFormat: "d-m-Y H:i",
      enableTime: true,
      enableSeconds: false
    },
    liveEvent: null,
    speakerList: [],
    selectedSpeaker: [],
    videoForm: {
      object_id: null,
      live_engine: "ivs"
    },
    video: null,
    session_id: null,
    filterList: [],
    quantityValid: true,
    products: [],
    videoList: [],
    related_product_ids_options: [],
    related_speaker_ids_options: [],
    related_product_ids_search: "",
    related_product_ids_input: [],
    related_speaker_ids_search: "",
    related_speaker_ids_input: [],
    related_video_ids_options: [],
    related_video_ids_search: "",
    related_video_ids_input: [],
    keywords_input: [],
    is_event_loaded: false,
    tags: [],
    tags_options: [],
    speakers: [],
    speakers_search: "",
    speakers_options: [],
    acceptFile: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
    popupActivo: false,
    posterImg: null,
    imageWidth: 0,
    imageHeight: 0
  }),
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    }),
    relatedEventSearchOptions() {
      return this.related_video_ids_options.filter(
        item =>
          !this.related_video_ids_input.find(ip => ip.value == item.value)
      );
    },
    relatedProductSearchOptions() {
      return this.related_product_ids_options.filter(
        item =>
          !this.related_product_ids_input.find(ip => ip.value == item.value)
      );
    },
    tag_select_options() {
      return this.tags_options.map(item => item.tag);
    },
    speakers_select_options() {
      return this.speakers_options
        .filter(item => item.speaker_id != this.speaker_id && !this.speakers.find(ip => ip.value == item.speaker_id))
        .map(item => {
          const mapped_item = {
            label: item.pro_name,
            value: item.speaker_id,
            item: item,
            poster: item.poster
          };
          return mapped_item;
        });
    }
  },
  created() {
    this.initLoad();
  },
  watch: {
    products(val) {
      this.related_product_ids_options = val.map(item => {
        const mapped_item = {
          label: item.pro_title,
          value: item.product_id,
          item: item,
          poster: item.poster
        };
        return mapped_item;
      });
      console.log("related_product_ids", this.form.related_product_ids);
      this.related_product_ids_input = this.form.related_product_ids
        ? this.form.related_product_ids
            .split(",")
            .map(item =>
              this.related_product_ids_options.find(ep => ep.value == item)
            )
            .filter(item => !!item)
        : [];
    },
    videoList(val) {
      this.related_video_ids_options = val.map(item => {
        const mapped_item = {
          label: item.pro_name,
          value: item.video_id,
          e: item.slug,
          poster: item.poster
        };
        return mapped_item;
      });
      this.is_event_loaded = true;
      setTimeout(() => {
        this.related_video_ids_input = this.form.related_video_ids
          ? this.form.related_video_ids
              .split(",")
              .map(item =>
                this.related_video_ids_options.find(ep => {
                  return ep.value == item;
                })
              )
              .filter(item => !!item)
          : [];
      }, 300);
    }
  },
  mounted() {
    this.setImageSize();
  },
  methods: {
    customTagFilter(option, search) {
      if (!search) return option;
      return option.filter(label=>label.toString().toLowerCase().includes(search.toLowerCase()));
    },
    onTagInput(newTags) {
      // Normalize newTags to avoid case-sensitive duplicates
      const normalizedTags = [];

      newTags.forEach(tag => {
        const lowerCaseTag = tag.toLowerCase();
        const existingTag = this.tag_select_options.find(
          option => option.toLowerCase() === lowerCaseTag
        );

        if (existingTag) {
          // Use the existing tag
          if (!normalizedTags.includes(existingTag)) {
            normalizedTags.push(existingTag);
          }
        } else {
          // Add the new tag both to the tags list and tag_select_options
          if (!normalizedTags.includes(tag)) {
            this.tag_select_options.push(tag);
            normalizedTags.push(tag);
          }
        }
      });

      // Update the tags without duplicates
      this.tags = normalizedTags;
    },
    async refetchOptionAndValue() {
      this.related_video_ids_input = this.form.related_video_ids
        ? this.form.related_video_ids
            .split(",")
            .map(item =>
              this.related_video_ids_options.find(ep => {
                return ep.value == item;
              })
            )
            .filter(item => !!item)
        : [];
      this.related_product_ids_input = this.form.related_product_ids
        ? this.form.related_product_ids
            .split(",")
            .map(item =>
              this.related_product_ids_options.find(ep => ep.value == item)
            )
            .filter(item => !!item)
        : [];
    },
    async loadVideo() {
      let dataMyVideo = {
        e: this.e,
        s: this.s,
        target: "merchant",
        perPage: 999,
        currentPage: 1
      };

      let paramsMyVideo = Object.keys(dataMyVideo)
        .map(key => key + "=" + dataMyVideo[key])
        .join("&");

      Service.Video.gets(paramsMyVideo)
        .then(res2 => {
          this.videoList = res2.data.rows;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async loadProduct() {
      let data = {
        e: this.e,
        s: this.s,
        perPage: 999
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      await Service.Product.getsInSeller(params).then(res => {
        this.products = res.data.rows;
        this.products.sort(this.compareValues("weight", "desc"));
      });
    },
    initLoad() {
      this.$vs.loading();
      setTimeout(async () => {
        if (this.e) {
          this.loadTag();
        }

        await this.loadSpeakers();
        // await this.loadProduct();
        await this.loadVideo();

        let data = {
          e: this.e,
          s: this.s,
          target: "merchant"
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        Service.Speakers.get(this.speaker_id, params)
          .then(res => {
            this.$vs.loading.close();

            let publish_status = 0;
            if (res.data.speaker.publish_status == 1) {
              publish_status = 1;
            }

            let listing_status = 0;
            if (res.data.speaker.listing_status == 1) {
              listing_status = 1;
            }

            this.form.e = this.e;
            this.form.s = this.s;
            this.form.speaker_id = res.data.speaker.speaker_id;
            this.form.pro_name = res.data.speaker.pro_name;
            this.form.slug = res.data.speaker.slug;
            this.form.pro_shortdesc = res.data.speaker.pro_shortdesc;
            this.form.publish_status = publish_status;
            this.form.listing_status = listing_status;
            this.posterImg = res.data.speaker.poster;
            this.form.poster = res.data.speaker.poster;

            this.form.related_video_ids = res.data.speaker.related_video_ids;
            this.form.related_product_ids =
              res.data.speaker.related_product_ids;
            console.log("related_product_ids", this.form.related_product_ids);

            this.speakers = res.data.speaker.related_speaker_ids
              ? res.data.speaker.related_speaker_ids.split(",")
                  .map(item => {
                    const speaker = this.speakers_options.find(
                      sp => sp.speaker_id == item
                    );
                    if (!speaker) return null;
                    const mapped_item = {
                      label: speaker.pro_name,
                      value: speaker.speaker_id,
                      item: speaker,
                      poster: speaker.poster
                    };
                    return mapped_item;
                  })
                  .filter(item => !!item)
              : [];

            this.tags = res.data.speaker.tag
              ? res.data.speaker.tag.map(item => item.tag)
              : [];
            this.refetchOptionAndValue();

            this.showDesc = false;
            setTimeout(() => {
              this.showDesc = true;
            }, 300);
          })
          .catch((e) => {
            console.error(e)
            /* this.$router.push("/pages/error-404").catch(() => {}); */
          });
      }, 800);
    },
    setImageSize() {
      let posterimage = document.querySelector("img");
      let w = posterimage.naturalWidth;
      let h = posterimage.naturalHeight;
      this.imageHeight = h;
      this.imageWidth = w;

      if (w > h) {
        this.imageWidth = 300;
        this.imageHeight = "auto";
      } else {
        this.imageHeight = 300;
        this.imageWidth = "auto";
      }
    },
    chooseImage() {
      document.getElementById("file-upload-img").click();
    },
    onUploadImages() {
      // this.basicForm.poster = this.$refs.fileImage.files[0]
      this.file.poster = this.$refs.fileImage.files[0];
      const reader = new FileReader();
      reader.onloadend = async () => {
        this.posterImg = reader.result;

        // var str = reader.result.split(',')[1]
        // var image = this.b64toBlob(str, "image/jpeg")
        // var imgURL = URL.createObjectURL(image)
        // this.posterUpdate = imgURL
        // this.basicForm.poster = reader.result
      };
      reader.readAsDataURL(this.$refs.fileImage.files[0]);
      this.$refs.fileImage.value = null;
      // this.uploadPoster(this.$refs.fileImage.files[0]);
    },
    removeposter() {
      this.file.poster = null;
      this.posterImg = null;
      this.popupActivo =false;
    },
    compareValues(key, order = "asc") {
      return function(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    // onAddEventRelated() {
    //   if (!this.related_speaker_ids_search) {
    //     return;
    //   }
    //   this.related_speaker_ids_input.push({
    //     label: this.related_speaker_ids_search.label,
    //     value: this.related_speaker_ids_search.value,
    //     e: this.related_speaker_ids_search.e,
    //     poster: this.related_speaker_ids_search.poster
    //   });
    //   this.related_speaker_ids_search = "";
    // },
    onAddEventRelated() {
      if (!this.related_video_ids_search) {
        return;
      }
      this.related_video_ids_input.push({
        label: this.related_video_ids_search.label,
        value: this.related_video_ids_search.value,
        e: this.related_video_ids_search.e,
        poster: this.related_video_ids_search.poster
      });
      this.related_video_ids_search = "";
    },
    onAddProductRelated() {
      if (!this.related_product_ids_search) {
        return;
      }
      this.related_product_ids_input.push({
        label: this.related_product_ids_search.label,
        value: this.related_product_ids_search.value,
        item: this.related_product_ids_search,
        poster: this.related_product_ids_search.poster
      });
      this.related_product_ids_search = "";
    },
    removeRelatedEvent(id) {
      this.related_video_ids_input = this.related_video_ids_input.filter(
        item => item.value != id
      );
    },
    removeRelatedProduct(id) {
      this.related_product_ids_input = this.related_product_ids_input.filter(
        item => item.value != id
      );
    },
    onAddSpeaker() {
      if (!this.speakers_search) {
        return;
      }
      this.speakers.push({
        label: this.speakers_search.label,
        value: this.speakers_search.value,
        item: this.speakers_search,
        poster: this.speakers_search.poster
      });
      this.speakers_search = "";
    },
    removeSpeaker(id) {
      this.speakers = this.speakers.filter(item => item.value != id);
    },
    quantityValidation() {
      if (this.form.qty === 0) {
        this.quantityValid = false;
      } else {
        this.quantityValid =
          this.form.qty === "" ||
          this.form.qty === null ||
          (!isNaN(this.form.qty) && this.form.qty > 0);
      }
    },
    async loadTag() {
      let filterData = {
        e: this.e,
        s: this.s
      };

      let params = Object.keys(filterData)
        .map(key => key + "=" + filterData[key])
        .join("&");

      const res = await Service.Tags.gets(params);
      this.tags_options = res.data.tags;
      return res.data.tags;
    },
    async loadSpeakers() {
      let dataMySpeaker = {
        e: this.e,
        s: this.s,
        target: "merchant",
        perPage: 999,
        currentPage: 1
      };

      let paramsMySpeaker = Object.keys(dataMySpeaker)
        .map(key => key + "=" + dataMySpeaker[key])
        .join("&");

      await Service.Speakers.gets(paramsMySpeaker)
        .then(res2 => {
          this.speakers_options = res2.data.rows;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async createTags(tags) {
      let params = {
        e: this.e,
        s: this.s,
        tags: tags
      };

      const res = await Service.Tags.create(params);
      return res.data.tags;
    },
    validateForm() {
      this.quantityValidation();
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    validateSlug() {
      this.$vs.loading();
      Service.Event.search(this.form.slug).then(res => {
        if (res.data.results.length > 0) {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : This slug already used by others.",
            color: "danger",
            fixed: true
          });
        }
        this.$vs.loading.close();
      });
    },
    createIVS() {
      let data = {
        e: this.liveEvent.slug,
        ivs_start: true
      };
      this.$vs.loading();
      Service.Event.update(data).then(res => {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });

        let rerun_status = 0;
        if (res.data.event.rerun_status) {
          rerun_status = 1;
        }

        this.form = {
          ...res.data.event,
          s: res.data.event.merchant.s,
          name: res.data.event.pro_name,
          slug: res.data.event.slug,
          daterange: [
            moment(res.data.event.datetime, "YYYY-MM-DD HH:mm:ss").unix() *
              1000,
            moment(res.data.event.datetime_end, "YYYY-MM-DD HH:mm:ss").unix() *
              1000
          ],
          selldaterange: [
            moment().format("YYYY-MM-DD HH:mm"),
            moment().format("YYYY-MM-DD HH:mm")
          ],
          shortdesc: res.data.event.pro_shortdesc + "",
          longdesc: res.data.event.pro_longdesc + "",
          timezone: res.data.event.timezone,
          venue: res.data.event.venue,
          qty: res.data.event.products[res.data.event.products.length - 1].qty,
          poster: res.data.event.poster,
          video_url: res.data.event.video_url,
          private_token: "",
          rerun_status: rerun_status
        };
        this.showDesc = false;
        setTimeout(() => {
          this.showDesc = true;
        }, 300);
        this.$vs.loading.close();
      });
    },
    async submit() {
      const resTags = await this.loadTag();

      const existedTags = resTags.filter(item =>
        this.tags.find(op => op == item.tag)
      );
      const needToCreatedTags = this.tags.filter(
        item => !resTags.find(op => op.tag == item)
      );
      const createdTags =
        needToCreatedTags && needToCreatedTags.length
          ? await this.createTags(needToCreatedTags)
          : [];

      this.form.related_product_ids = this.related_product_ids_input
        .map(item => item.value)
        .join(",");
      console.log("related_video_ids_input", this.related_video_ids_input);
      this.form.related_video_ids = this.related_video_ids_input
        .map(item => {
          console.log("item", item);
          return item.value;
        })
        .join(",");

      this.form.related_speaker_ids = this.speakers
        .map(item => item.value)
        .join(",");

      this.form.tags = [
        ...existedTags.map(item => item.tag_id),
        ...createdTags.map(item => item.tag_id)
      ];
      // const qty = this.form.qty;

      this.$vs.loading();

      // var formData = new FormData();

      // for (var key in this.form) {
      //   formData.append(key, this.form[key]);
      // }
      // if (this.file.poster != null) {
      //   formData.append("poster", this.file.poster);
      // }

      Service.Speakers.update(this.form.speaker_id, this.form)
        .then(async res => {
          // this.form.qty = qty;
          try {
            if (res.success) {
              // this.$vs.notify({
              //   title: "Success",
              //   text: "Update complete.",
              //   color: "success"
              // });
              await this.doUploadFile();
            }
            this.initLoad();
          } catch (e) {
            this.initLoad();
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    eventSubmit() {
      let data = {
        e: this.liveEvent.slug,
        live_engine: this.form.live_engine,
        live_engine_2: this.form.live_engine_2,
        vimeo_playback_url: this.form.vimeo_playback_url,
        dacast_playback_url: this.form.dacast_playback_url,
        ivs_creator_endpoint_url: this.form.ivs_creator_endpoint_url,
        ivs_creator_stream_key: this.form.ivs_creator_stream_key,
        ivs_viewer_endpoint_url: this.form.ivs_viewer_endpoint_url,
        ivs_channel_id: this.form.ivs_channel_id,
        ivs_playback_url: this.form.ivs_playback_url,
        rerun_status: 0,
        publish_status: 0,
        listing_status: 0,
        mode: this.form.mode
      };

      if (this.form.rerun_status == 1) {
        data.rerun_status = 1;
      }

      if (this.form.publish_status == 1) {
        data.publish_status = 1;
      }

      if (this.form.listing_status == 1) {
        data.listing_status = 1;
      }

      this.$vs.loading();
      Service.Event.update(data).then(() => {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
        this.$vs.loading.close();
      });
    },
    liveEventSubmit() {
      let data = {
        event_id: this.liveEvent.event_id,
        speaker_ids: [],
        event_filter: this.event_filter,
        e: this.e
      };
      this.selectedSpeaker.map(item => {
        data.speaker_ids.push(item.value);
      });
      this.$vs.loading();
      Service.VideoEvent.update(data).then(() => {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
        this.$vs.loading.close();
      });
    },
    liveVideoSubmit() {
      let data = { e: this.e };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();
      Service.Event.createVideo(params, this.videoForm).then(() => {
        let data = {
          e: this.e
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        Service.Event.getVideo(this.liveEvent.event_id, params).then(video => {
          if (video.data.video != null) {
            this.video = video.data.video;
          }
          this.$vs.loading.close();
        });
      });
    },
    liveVideoUpdate() {
      let data = { e: this.e };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();
      Service.Event.updateVideo(params, this.video)
        .then(res => {
          console.log(res);
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    setPoster(e) {
      this.file.poster = e.target.files[0];
    },
    async doUploadFile() {
      if (this.file.poster != null) {
        this.$vs.loading();
        var formData = new FormData();
        formData.append("e", this.e);
        formData.append("s", this.s);
        formData.append("target", "merchant");
        formData.append("poster", this.file.poster);

        await Service.Speakers.update(this.form.speaker_id, formData)
          .then(res => {
            // this.form.qty = qty;
            if (res.success) {
              this.$vs.notify({
                title: "Success",
                text: "Update complete.",
                color: "success"
              });
            }
            this.$vs.loading.close();
          })
          .catch(err => {
            this.$vs.notify({
              title: "Oops!",
              text: "ERROR : " + err.error,
              color: "danger"
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
      }
    }
  }
};
</script>
<style>
.editor {
  height: 10rem;
  margin-bottom: 0px;
}
</style>
